import { Controller } from '@hotwired/stimulus';
import { getModalById, getModalByUrl } from '../utilities/modal';

export default class extends Controller {
    async openModal(event) {
        event.preventDefault();

        if (!event.params.id && !event.params.url) {
            throw Error('No [id] or [url] param provided.');
        }

        let modalController = null;

        const target = event.currentTarget;

        if (event.params.id) {
            modalController = getModalById(event.params.id);
        } else if (event.params.url) {
            if (target && target.classList.contains('btn')) {
                target.classList.add('loading');
            }
            modalController = await getModalByUrl(event.params.url);
        }

        if (target && target.classList.contains('loading')) {
            target.classList.remove('loading');
        }

        modalController?.open();
    }

    handleInput(e) {
        this.max = e.currentTarget.dataset.max;
        this.min = e.currentTarget.dataset.min;

        this.clearInputError(e.currentTarget);

        e.currentTarget.value = parseInt(e.currentTarget.value);

        if (parseInt(e.currentTarget.value) > parseInt(this.max)) {
            e.currentTarget.value = this.max;

            this.handleInputError(e.currentTarget);
        }

        if (parseInt(e.currentTarget.value) < parseInt(this.min)) {
            e.currentTarget.value = this.min;

            this.handleInputError(e.currentTarget);
        }
    }

    handleInputError(el) {
        el.classList.add('invalid');

        const messageNode = document.createElement('span');
        messageNode.classList.add('input-error');
        messageNode.innerHTML = `Įvesti galima nuo ${this.min} iki ${this.max}`;

        el.parentNode.appendChild(messageNode);
    }

    clearInputError(el) {
        el.classList.remove('invalid');
        document.querySelectorAll('.input-error').forEach((node) => node.remove());
    }
}
